module.exports = __webpack_public_path__ + "static/DesignsIntoCode2x-e5a71cdd9938890a6f255605b6982b40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/marvel-vs-zeplin/DesignsIntoCode2x.jpg
// module id = 2665
// module chunks = 21098653631116